"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _logo = _interopRequireDefault(require("../../img/logo.svg"));

var _iconsMaterial = require("@mui/icons-material");

var _ChuiContext = require("../../Hooks/ChuiContext");

var _SelectLanguageButton = _interopRequireDefault(require("../../FormsUI/Button/SelectLanguageButton.js"));

var _SelectTextSizeButton = _interopRequireDefault(require("../../FormsUI/Button/SelectTextSizeButton.js"));

var _TextSizeSelectDialog = _interopRequireDefault(require("../../FormsUI/DialogBox/TextSizeSelectDialog.js"));

var _LanguageSelectDialog = _interopRequireDefault(require("../../FormsUI/DialogBox/LanguageSelectDialog.js"));

var _excluded = ["children", "includeTranslation", "title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CHUIAppBar = function CHUIAppBar(_ref) {
  var children = _ref.children,
      includeTranslation = _ref.includeTranslation,
      title = _ref.title,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var theme = (0, _material.useTheme)(); //breakpoint is the min screen size before changing to mobile view

  var breakpoint = 620;

  var _useCHUIDarkModeConte = (0, _ChuiContext.useCHUIDarkModeContext)(),
      prefersDarkMode = _useCHUIDarkModeConte.prefersDarkMode,
      setPrefersDarkMode = _useCHUIDarkModeConte.setPrefersDarkMode;

  var _useCHUILanguageConte = (0, _ChuiContext.useCHUILanguageContext)(),
      selectedLanguage = _useCHUILanguageConte.selectedLanguage,
      setSelectedLanguage = _useCHUILanguageConte.setSelectedLanguage;

  var _useCHUIAbrLanguageCo = (0, _ChuiContext.useCHUIAbrLanguageContext)(),
      selectedAbrLanguage = _useCHUIAbrLanguageCo.selectedAbrLanguage,
      setSelectedAbrLanguage = _useCHUIAbrLanguageCo.setSelectedAbrLanguage;

  var _useCHUIOldAbrLanguag = (0, _ChuiContext.useCHUIOldAbrLanguageContext)(),
      selectedOldAbrLanguage = _useCHUIOldAbrLanguag.selectedOldAbrLanguage,
      setSelectedOldAbrLanguage = _useCHUIOldAbrLanguag.setSelectedOldAbrLanguage;

  var _useCHUITextSizeConte = (0, _ChuiContext.useCHUITextSizeContext)(),
      selectedTextSize = _useCHUITextSizeConte.selectedTextSize,
      setSelectedTextSize = _useCHUITextSizeConte.setSelectedTextSize;

  var _useCHUIUserSelectedL = (0, _ChuiContext.useCHUIUserSelectedLanguageContext)(),
      userSelectedLanguage = _useCHUIUserSelectedL.userSelectedLanguage,
      setUserSelectedLanguage = _useCHUIUserSelectedL.setUserSelectedLanguage;

  var _useCHUIAbrRegionCont = (0, _ChuiContext.useCHUIAbrRegionContext)(),
      selectedAbrRegion = _useCHUIAbrRegionCont.selectedAbrRegion,
      setSelectedAbrRegion = _useCHUIAbrRegionCont.setSelectedAbrRegion;

  var _useCHUILanguageSuppo = (0, _ChuiContext.useCHUILanguageSupportContext)(),
      languageSupport = _useCHUILanguageSuppo.languageSupport,
      setLanguageSupport = _useCHUILanguageSuppo.setLanguageSupport;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      openLanguageSelect = _useState2[0],
      setOpenLanguageSelect = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openTextSizeSelect = _useState4[0],
      setOpenTextSizeSelect = _useState4[1];

  var _useState5 = (0, _react.useState)(window.innerWidth),
      _useState6 = _slicedToArray(_useState5, 2),
      width = _useState6[0],
      setWidth = _useState6[1];

  (0, _react.useEffect)(function () {
    window.addEventListener("resize", function () {
      return setWidth(window.innerWidth);
    });
  }, []);

  var handleClickOpenLanguageSelect = function handleClickOpenLanguageSelect() {
    setOpenLanguageSelect(true);
  };

  var handleClickOpenTextSizeSelect = function handleClickOpenTextSizeSelect() {
    setOpenTextSizeSelect(true);
  };

  var handleTextSizeSelect = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(textSize) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setOpenTextSizeSelect(false);
              setSelectedTextSize(textSize);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleTextSizeSelect(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleLanguageSelect = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(language, abrLanguage, abrRegion, support) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setOpenLanguageSelect(false);

              if (abrLanguage != selectedAbrLanguage && abrLanguage != null) {
                setSelectedOldAbrLanguage(selectedAbrLanguage);
                setSelectedAbrLanguage(abrLanguage);
                setSelectedLanguage(language);
              }

              setSelectedAbrRegion(abrRegion != null ? abrRegion : selectedAbrRegion);
              setLanguageSupport(support != null ? support : languageSupport);
              setUserSelectedLanguage(true);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleLanguageSelect(_x2, _x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement("div", {
    sx: {
      flexGrow: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_material.AppBar, {
    position: "static"
  }, /*#__PURE__*/_react.default.createElement(_material.Toolbar, null, /*#__PURE__*/_react.default.createElement("img", {
    src: _logo.default,
    sx: {
      marginRight: theme.spacing(2),
      justifyContent: "left"
    },
    width: "142px",
    height: "64px",
    alt: "Connect Health logo",
    tabIndex: "1"
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h6",
    noWrap: true
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flexGrow: "1"
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: width < breakpoint ? {
      display: "flex"
    } : {
      display: "flex",
      gap: "1.5rem"
    }
  }, includeTranslation && /*#__PURE__*/_react.default.createElement(_SelectLanguageButton.default, {
    width: width,
    breakpoint: breakpoint,
    edge: "start",
    color: "inherit",
    tabIndex: "2",
    onClick: function onClick() {
      return handleClickOpenLanguageSelect();
    }
  }, selectedLanguage), /*#__PURE__*/_react.default.createElement(_SelectTextSizeButton.default, {
    width: width,
    breakpoint: breakpoint,
    edge: "start",
    color: "inherit",
    tabIndex: "3",
    onClick: function onClick() {
      return handleClickOpenTextSizeSelect(selectedTextSize);
    }
  }, selectedTextSize), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    edge: "start",
    color: "inherit",
    tabIndex: "4",
    "aria-label": prefersDarkMode ? "Click to select light colour theme" : "Click to select dark   colour theme",
    onClick: function onClick() {
      setPrefersDarkMode(!prefersDarkMode);
      localStorage.setItem("CHUIDarkMode", !prefersDarkMode);
    },
    size: "large"
  }, prefersDarkMode ? /*#__PURE__*/_react.default.createElement(_iconsMaterial.Brightness7, null) : /*#__PURE__*/_react.default.createElement(_iconsMaterial.Brightness4, null))))), /*#__PURE__*/_react.default.createElement(_LanguageSelectDialog.default, {
    selectedValue: selectedLanguage,
    open: openLanguageSelect,
    onClose: handleLanguageSelect
  }), /*#__PURE__*/_react.default.createElement(_TextSizeSelectDialog.default, {
    selectedValue: selectedTextSize,
    open: openTextSizeSelect,
    onClose: handleTextSizeSelect
  }));
};

var _default = CHUIAppBar;
exports.default = _default;